/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { TransactionTypeDto } from '../../models/transaction-type-dto';

export interface ApiTransactiontypeGet$Params {
  'api-version'?: string;
}

export function apiTransactiontypeGet(http: HttpClient, rootUrl: string, params?: ApiTransactiontypeGet$Params, context?: HttpContext): Observable<StrictHttpResponse<Array<TransactionTypeDto>>> {
  const rb = new RequestBuilder(rootUrl, apiTransactiontypeGet.PATH, 'get');
  if (params) {
    rb.query('api-version', params['api-version'], {});
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<Array<TransactionTypeDto>>;
    })
  );
}

apiTransactiontypeGet.PATH = '/api/transactiontype';
